import clsx from 'clsx';
import { observer } from 'mobx-react';
import Button from '../../../../../../../Form/Button';
import ReclaimLicensesStore from '../../../Store';

interface Props {
  reclaimLicensesStore: ReclaimLicensesStore;
}

function SubmitButton({ reclaimLicensesStore }: Props) {
  return (
    <Button
      type="button"
      value="Submit"
      onClick={reclaimLicensesStore.update}
      data-intercom-target="reclaim-licenses-submit-button"
      className={clsx(
        'rounded-md border border-solid bg-teal-600 ml-4',
        'py-2.5 px-5 text-sm font-semibold text-white',
      )}
    />
  );
}

export default observer(SubmitButton);
